export const BREAKPOINTS = {
  mobile: 769,
  tablet: 1025,
  desktop: 1217,
  widescreen: 1408,
  fullhd: Infinity,
};
